<template>
  <t-form label-width="100px">
    <div class="formItemDiv">样式：</div>
    <t-row>
      <t-col :span="6" v-for="item in decorationTypes" :key="item.value">
        <div style="height: 80px;overflow: hidden;cursor: pointer" @click="attribute.decorationType = item.value">
          <component :is="item.value" style="height: 80px;"/>
        </div>
      </t-col>
    </t-row>
    <t-form-item label="颜色1">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.color1" enableAlpha/>
    </t-form-item>
    <t-form-item label="颜色2">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.color2" enableAlpha/>
    </t-form-item>

    <div v-if="attribute.decorationType === 'dv-decoration-7'
      || attribute.decorationType === 'dv-decoration-9' || attribute.decorationType === 'dv-decoration-11'
      || attribute.decorationType === 'dv-decoration-12'">
      <t-form-item label="文本">
        <t-input size="small" v-model="attribute.text"/>
      </t-form-item>
      <t-form-item label="颜色3">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.textColor" enableAlpha/>
      </t-form-item>
    </div>
  </t-form>
</template>

<script>
export default {
  name: "cpt-dataV-decoration-option",
  props: { attribute: Object },
  data() {
    return {
      decorationTypes: [
        { label: '样式1', value: 'dv-decoration-1' },
        { label: '样式2', value: 'dv-decoration-2' },
        { label: '样式3', value: 'dv-decoration-3' },
        { label: '样式4', value: 'dv-decoration-4' },
        { label: '样式5', value: 'dv-decoration-5' },
        { label: '样式6', value: 'dv-decoration-6' },
        { label: '样式7', value: 'dv-decoration-7' },
        { label: '样式8', value: 'dv-decoration-8' },
        { label: '样式9', value: 'dv-decoration-9' },
        { label: '样式10', value: 'dv-decoration-10' },
        { label: '样式11', value: 'dv-decoration-11' },
        { label: '样式12', value: 'dv-decoration-12' },
      ]
    }
  }
}
</script>

<style scoped>
.formItemDiv{width: 100%;line-height: 30px;text-indent: 1em;font-size: 13px;color: var(--td-text-color-primary)}
</style>
